import { AppRoutes } from '@/routes';
import { Toaster } from '@/components/ui/sonner';
import { Toaster as ShadcnToaster } from '@/components/ui/toaster';
import { SessaoExpiradaDialog } from '@/components/shared/SessaoExpiradaDialog';
import { HeaderProvider, AuthProvider } from '@/contexts';

export function App() {
  return (
    <AuthProvider>
      <HeaderProvider>
        <AppRoutes />
        <SessaoExpiradaDialog />
        <Toaster />
        <ShadcnToaster />
      </HeaderProvider>
    </AuthProvider>
  );
}
